import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 加载中
 */
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import Spin from 'antd/es/spin';
import { isValidElement } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Icon } from '../Icon';
export const Loading = ({ className, style, loading = false, children, tip, size = 'default', inline = false, }) => inline ? (_jsx(Indicator, { size: size, inline: inline }, void 0)) : isValidElement(children) ? (_jsx(StyleSpin, Object.assign({ size: size, spinning: loading, tip: tip, indicator: _jsx(Indicator, { size: size }, void 0) }, { children: children }), void 0)) : (_jsx(FlexContainer, Object.assign({ style: style, className: className }, { children: _jsx(Indicator, {}, void 0) }), void 0));
const FontSize = {
    default: 18,
    small: 16,
    large: 40,
};
const Indicator = ({ size = 'default', inline, }) => {
    const theme = useTheme();
    return (_jsx(IndicatorIcon, { icon: faSpinnerThird, spin: true, style: { fontSize: FontSize[size] }, color: theme.brand._1, "$inline": inline }, void 0));
};
const FlexContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 160px;
`;
const IndicatorIcon = styled(Icon) `
  animation-duration: 1s;
  ${p => !p.$inline &&
    css `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `};
`;
// todo tip 文字大小设计暂未提供规范，此次先适配 large
const StyleSpin = styled(Spin) `
  ${props => props.size === 'large'
    ? `
.ant-spin-text {
  font-size: 16px;
  font-weight: 600;
  color: rgba(6, 12, 25, 0.85);
  margin-top: 20px;
}`
    : ''}
`;
//# sourceMappingURL=data:application/json;base64,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